// extracted by mini-css-extract-plugin
module.exports = {"btn":"C_p v_sf v_rZ h_fp h_fD h_fs h_hf","full":"C_tv h_dp h_dz"};